import { useSplashBlocker } from '@app/core/splash/useSplashBlocker';
import { useGrowthbookUserInit } from '../hooks/useGrowthbookUserInit';
import { useBugsnagIdentify } from './bugsnag/useBugsnagIdentify';
import { PostHogProviderWrapper } from './posthog/PostHogProviderWrapper';
import { PostHogTracking } from './posthog/PostHogTracking';

export function IntegrationsTracking({ children }: { children: React.ReactNode }) {
  useBugsnagIdentify();

  const growthbookReady = useGrowthbookUserInit();
  useSplashBlocker('integrations', !growthbookReady);

  if (!growthbookReady) {
    return null;
  }

  return (
    <PostHogProviderWrapper>
      <PostHogTracking />
      {children}
    </PostHogProviderWrapper>
  );
}
